import { DealRequest } from '@/app/api/types';
import { Stack } from '@mui/material';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useAppSelector } from '@/app/hooks';
import {
  CHRONOLOGY_STEPS_COUNT,
  getChronologySteps,
} from '../lib/get-chronology-steps';
import { getCurrentStep } from '../lib/get-current-step';
import { getStepStatus } from '../lib/get-step-status';
import { ChronologyDirection } from '../types';
import { ChronologyItem } from './chronology-item';

interface ChronologyFlowProps {
  row?: DealRequest;
  direction?: ChronologyDirection;
}

export const ChronologyFlow: FC<ChronologyFlowProps> = ({
  row,
  direction = 'vertical',
}) => {
  const { t } = useTranslation();
  const viewerTin = useAppSelector((state) => state.auth.profile?.tin);

  if (!row) return null;

  const currentStep = getCurrentStep(row);
  const steps = getChronologySteps(row, t, viewerTin);
  const isHorizontal = direction === 'horizontal';

  /**
   * Если часть шагов скрыта (отклонение), оставшиеся не растягиваем на всю
   * ширину — они остаются на своих местах, справа остаётся пустое место.
   */
  const columnWidth =
    isHorizontal && steps.length < CHRONOLOGY_STEPS_COUNT
      ? `${100 / CHRONOLOGY_STEPS_COUNT}%`
      : undefined;

  return (
    <Stack
      direction={isHorizontal ? 'row' : 'column'}
      alignItems={isHorizontal ? 'flex-start' : 'stretch'}
    >
      {steps.map((step, index) => (
        <ChronologyItem
          key={step.id}
          step={step}
          status={getStepStatus(index, currentStep)}
          isLast={index === steps.length - 1}
          direction={direction}
          columnWidth={columnWidth}
        />
      ))}
    </Stack>
  );
};
